(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("emheader", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["emheader"] = factory(require("vue"));
	else
		root["emheader"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_vue__) {
return 